const paddingOptionMapping = {
  '0px (0rem)': '0rem',
  '32px (2rem)': '2rem',
  '64px (4rem)': '4rem'
};

const textOptionsMapping = {
  'Text box left': true,
  'Text box right': false
};

const galleryOrderMapping = {
  'Display first node first': false,
  'Display first node last': true
};

const galleryRatioMapping = {
  'Use uploaded media': 'dynamic',
  '4x3 image ratio': '4:3'
};

const galleryGridWidthMapping = {
  '2 columns': 2,
  '3 columns': 3,
  '4 columns': 4,
  '5 columns': 5
};

const galleryLoadingBehaviour = {
  'Load all cards at once': 'all',
  'Load 25 cards at a time': '25'
};

const yesOrNoToBoolean = {
  Yes: true,
  No: false
};

const donateOrientationMapping = {
  'Form left': 'left',
  'Form right': 'right'
};

export {
  paddingOptionMapping,
  textOptionsMapping,
  galleryOrderMapping,
  galleryRatioMapping,
  galleryGridWidthMapping,
  galleryLoadingBehaviour,
  yesOrNoToBoolean,
  donateOrientationMapping
};
